/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WorkflowFailureRecipient,
  WorkflowFailureRecipientListResponse,
  WorkflowFailureRecipientPostRequest,
} from '../models/index';
import {
    WorkflowFailureRecipientFromJSON,
    WorkflowFailureRecipientToJSON,
    WorkflowFailureRecipientListResponseFromJSON,
    WorkflowFailureRecipientListResponseToJSON,
    WorkflowFailureRecipientPostRequestFromJSON,
    WorkflowFailureRecipientPostRequestToJSON,
} from '../models/index';

export interface AddWorkflowFailureRecipientRequest {
    workflowFailureRecipientPostRequest: WorkflowFailureRecipientPostRequest;
}

export interface RemoveWorkflowFailureRecipientRequest {
    recipientId: string;
}

/**
 * WorkflowFailureRecipientsApi - interface
 * 
 * @export
 * @interface WorkflowFailureRecipientsApiInterface
 */
export interface WorkflowFailureRecipientsApiInterface {
    /**
     * Idempotent — adding the same email twice returns the existing recipient.
     * @summary Add an email to the workflow failure recipient list.
     * @param {WorkflowFailureRecipientPostRequest} workflowFailureRecipientPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowFailureRecipientsApiInterface
     */
    addWorkflowFailureRecipientRaw(requestParameters: AddWorkflowFailureRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowFailureRecipient>>;

    /**
     * Idempotent — adding the same email twice returns the existing recipient.
     * Add an email to the workflow failure recipient list.
     */
    addWorkflowFailureRecipient(requestParameters: AddWorkflowFailureRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowFailureRecipient>;

    /**
     * 
     * @summary List workflow failure email recipients for the current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowFailureRecipientsApiInterface
     */
    listWorkflowFailureRecipientsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowFailureRecipientListResponse>>;

    /**
     * List workflow failure email recipients for the current tenant.
     */
    listWorkflowFailureRecipients(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowFailureRecipientListResponse>;

    /**
     * 
     * @summary Remove a workflow failure recipient by id.
     * @param {string} recipientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowFailureRecipientsApiInterface
     */
    removeWorkflowFailureRecipientRaw(requestParameters: RemoveWorkflowFailureRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a workflow failure recipient by id.
     */
    removeWorkflowFailureRecipient(requestParameters: RemoveWorkflowFailureRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class WorkflowFailureRecipientsApi extends runtime.BaseAPI implements WorkflowFailureRecipientsApiInterface {

    /**
     * Idempotent — adding the same email twice returns the existing recipient.
     * Add an email to the workflow failure recipient list.
     */
    async addWorkflowFailureRecipientRaw(requestParameters: AddWorkflowFailureRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowFailureRecipient>> {
        if (requestParameters['workflowFailureRecipientPostRequest'] == null) {
            throw new runtime.RequiredError(
                'workflowFailureRecipientPostRequest',
                'Required parameter "workflowFailureRecipientPostRequest" was null or undefined when calling addWorkflowFailureRecipient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/workflow-failure-recipients`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkflowFailureRecipientPostRequestToJSON(requestParameters['workflowFailureRecipientPostRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowFailureRecipientFromJSON(jsonValue));
    }

    /**
     * Idempotent — adding the same email twice returns the existing recipient.
     * Add an email to the workflow failure recipient list.
     */
    async addWorkflowFailureRecipient(requestParameters: AddWorkflowFailureRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowFailureRecipient> {
        const response = await this.addWorkflowFailureRecipientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List workflow failure email recipients for the current tenant.
     */
    async listWorkflowFailureRecipientsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowFailureRecipientListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/workflow-failure-recipients`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowFailureRecipientListResponseFromJSON(jsonValue));
    }

    /**
     * List workflow failure email recipients for the current tenant.
     */
    async listWorkflowFailureRecipients(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowFailureRecipientListResponse> {
        const response = await this.listWorkflowFailureRecipientsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Remove a workflow failure recipient by id.
     */
    async removeWorkflowFailureRecipientRaw(requestParameters: RemoveWorkflowFailureRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['recipientId'] == null) {
            throw new runtime.RequiredError(
                'recipientId',
                'Required parameter "recipientId" was null or undefined when calling removeWorkflowFailureRecipient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/workflow-failure-recipients/{recipient_id}`.replace(`{${"recipient_id"}}`, encodeURIComponent(String(requestParameters['recipientId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a workflow failure recipient by id.
     */
    async removeWorkflowFailureRecipient(requestParameters: RemoveWorkflowFailureRecipientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeWorkflowFailureRecipientRaw(requestParameters, initOverrides);
    }

}
